<template>
  <div class="container">
    <app-header title="BOM表配单"/>
    <div class="main">
      <div class="tip">注意：上传图片时请在文件里注明：求购人姓名/联系方式/公司名称</div>
      <div class="image">
        <div class="item" v-for="(item,index) in fileList" :key="index">
          <img :src="item.url"  alt="图片" class="imgPreview">
          <van-icon name="close" @click="delImg(index)" class="delte"/>
        </div>
        <van-uploader  :after-read="afterRead" :accept="accept"  upload-icon="plus" />
      </div>
    </div>
    <div class="submit" @click="handleShow">提交</div>
    <div class="my-container">
      <van-popup v-model="show" get-container="#my-container" :style="{ height: '400px',width: '90%',borderRadius: '6px' }">
        <div class="content">
          <div><img src="@/assets/close.png" alt="关闭" width="16" height="16" @click="show = false"></div>
          <div class="title">请填写联系人信息，更加方便提供服务！</div>
          <div class="form-item">
            <label for="username">联系人</label>
            <!--<input type="text" id="name">-->
            <page-input v-model="row.username" class="input" id="username"/>
          </div>
          <div class="form-item">
            <label for="phone">联系电话</label>
            <!--<input type="text" id="tel">-->
            <page-input v-model="row.phone" class="input" id="phone"/>
          </div>
          <div class="form-item">
            <label for="company">公司名称</label>
            <!--<input type="text" id="compony">-->
            <page-input v-model="row.company" class="input" id="company"/>
          </div>
          <div class="submit" @click="onSubmit">完成</div>
        </div>
      </van-popup>
    </div>
  </div>
</template>

<script>
  import { image } from '@/api/file'
  import { saveShopPurchase } from '@/api/purchase'
  export default {
    name: "file",
    data(){
      return{
        show: false,
        accept: 'image/*',
        // 图片列表
        fileList: [],
        row: {
          type: 0,
          file: '',
          uid: '',
          username: '',
          phone: '',
          company: '',
          fileType: 1,
          fromType : 1
        }
      }
    },
    created(){
      this.row.type = this.$route.query.type
    },
    methods: {
      handleShow(){
        if (this.fileList.length <= 0){
          this.$toast.fail('请选择上传的图片');
          return;
        }
        this.show = true
      },
      onSubmit() {
        if (!this.row.username){
          this.$toast.fail('请填写用户名');
          return;
        }
        if (!this.row.phone){
          this.$toast.fail('请填写手机号码');
          return;
        }
        if (!this.row.company){
          this.$toast.fail('请填写公司名称');
          return;
        }
        let values = JSON.stringify(this.fileList)
        this.row.file = values
        var user = localStorage.getItem('userInfo')
        if (!user){
          this.$router.push({path: '/login'})
          return;
        }
        user = JSON.parse(user)
        this.row.uid = user.id
        saveShopPurchase(this.row).then((res)=>{
          if (res.success) {
            this.$toast.success('成功');
            this.show = false
            setTimeout(() => {
              this.$router.go(-1)
            },2500)
          }
        })
      },
      afterRead(file) {
        console.log('输出file:',file)
        this.upload(file);
      },
      upload(file){
        let formData = new FormData()
        formData.append('file', file.file)
        image(formData).then(res => {
          if (res.success) {
            this.fileList.push({
              name: file.file.name,
              url: res.data
            }); //上传一张之后压入这个数组
          }else{
            this.$toast.fail(res.msg)
          }
        }).catch(err=>{

        })
      },
      delImg (index) {
        // 删除指定下标的图片对象
        if (isNaN(index) || index >= this.fileList.length) {
          return false
        }
        let tmp = []
        for (let i = 0, len = this.fileList.length; i < len; i++) {
          if (this.fileList[i] !== this.fileList[index]) {
            tmp.push(this.fileList[i])
          }
        }
        this.fileList = tmp
      },
    }
  }
</script>

<style lang="less" scoped>
  .container{
    width: 100vw;
    height: auto;
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    overflow-y: scroll;
    padding-bottom: 60px;
    font-size: 14px;
    .main{
      padding: 12px;
      .tip{
        font-size:10px;
        font-weight:400;
        line-height:14px;
        color:rgba(254,0,59,1);
      }
      .excel{
        display: flex;
        flex-direction: row;
        align-items: center;
        padding: 10px 0 8px 0;
        .name{
          flex: 1;
          margin-left: 15px;
          overflow: hidden;
        }
      }
      .image{
        padding: 10px 16px;
        display: flex;
        flex-direction: row;
        flex-wrap: wrap;
        box-sizing: border-box;
        width: 100%;
        padding: 10px 0px;
        overflow: hidden;
        .item{
          display: block;
          width: 80px;
          height: 80px;
          border-radius: 8px;
          position: relative;
          margin: 0 8px 8px 0;
          cursor: pointer;
          .imgPreview{
            width: 80px;
            height: 80px;
          }
          .delte{
            position: absolute;
            top: -8px;
            right: -8px;
            color: #969799;
            font-size: 18px;
            background-color: #fff;
            border-radius: 100%;
          }
        }
      }
    }
    .submit{
      position: fixed;

      right: 12px;
      bottom: 12px;
      left: 12px;
      height: 50px;
      line-height: 50px;
      background: #F1124C;
      text-align: center;
      color: #ffffff;
      border-radius: 5px;
    }
    .my-container{
      .content{
        padding: 10px;
        .title{
          height:22px;
          font-size:16px;
          font-weight:bold;
          color:rgba(51,51,51,1);
          text-align: center;
        }
        .form-item{
          display: flex;
          flex-direction: row;
          padding: 0 15px;
          margin-top: 25px;
          label{
            width: 75px;
            height: 40px;
            line-height: 40px;
            display: inline-block;
          }
          .input{
            //height:40px;
            border:1px solid rgba(243,243,243,1);
            border-radius:4px;
            padding: 10px;
          }
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/bom/image.vue